<div *ngIf="entity && customFields && form" [editorType]="'small'">
  <form [formGroup]="form">
    <div class="column">
      <div class="group">
        <div class="title">{{ 'common.data' | translate | ucfirst }}</div>
        <dx-text-area formControlName="description" formField required></dx-text-area>
        <dx-text-area formControlName="reference" formField minlength="2"></dx-text-area>
        <dx-date-box type="date" formField required formControlName="date"></dx-date-box>
        <dx-select-box formControlName="organizationId" formField required
          [dataSource]="organizations!" displayExpr="legalName" valueExpr="id"
          [placeholder]="'entity.consignmentStock.organizationId' | translate | ucfirst"
        />
      </div>
    </div>
  </form>
</div>
